import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function formatBytes(bytes: number | null): string {
  if (bytes === null) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatDateTime(value: string | null): string {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString();
}

/**
 * Google Ads reports no descriptive name for many accounts, so a target's name
 * is often our own `Customer <id>` fallback. Repeating the id after it reads as
 * a bug, so the account line collapses to whichever half carries information.
 */
export function formatAccountLine(name: string, externalTargetId: string): string {
  return name.includes(externalTargetId) ? name : `${name} · ${externalTargetId}`;
}

/** Layout dimensions are only pixels when the layout was authored in pixels. */
export function formatDimensions(
  width: number | null,
  height: number | null,
  unit: string | null,
): string {
  if (width === null || height === null) return unit ? `measured in ${unit}` : '—';
  return `${width} × ${height}${unit && unit !== 'px' ? ` ${unit}` : ' px'}`;
}
